export const Types = {
  SUCCESS: 0,
  ERROR: 1,
  WARNING: 2,
  MASSIVA: 3,
};

export const Timeout = {
  SUCCESS: 5000,
  ERROR: 10000,
  WARNING: 5000,
  MASSIVA: 5000,
};

export const StatoOperazione = {
  PENDING: 0,
  COMPLETED: 1,
};

export const MAX_TEXT_LENGTH = 77;

export const PENDING_OPERATION = 'Elaborazione in corso...';

export const COMPLETED_OPERATION = 'Elaborazione terminata';
